import find from 'lodash/find';
import Breadcrumb from '@Services/Breadcrumb';
import History from '@Services/History';

import { searchId as searchIdSelector } from '@Selectors/StateParamsSelectors';
import { breadcrumbBaseParams as breadcrumbBaseParamsSelector } from './performSearchFilterAsyncSelectors';

export function getOriginalSearch({ heatmapMode, searchFilterBaseParams }) {
  const recentSearches = History.retrieveRecentHistoryWithoutZeroResults();
  const searchObj = heatmapMode
    ? { heatmapResultName: searchFilterBaseParams.resultName }
    : { resultName: searchFilterBaseParams.resultName };

  return find(recentSearches, searchObj) || {};
}

export function getSearchId(originalSearch, state) {
  const searchId = searchIdSelector(state);

  return originalSearch.searchId || searchId;
}

export default function prepareBreadCrumb({
  state,
  facets,
  responseItem,
  searchFilterResult,
  baseParamsExtension,
  searchFilterBaseParams,
  heatmapMode,
}) {
  const breadcrumbBaseParams = breadcrumbBaseParamsSelector(state);
  const { synthesisPlanId, synthesisProducts, synthesisBranchId } = Breadcrumb.getActiveBreadcrumbForDb(searchFilterBaseParams.databaseId);

  const originalSearch = getOriginalSearch({
    heatmapMode,
    searchFilterBaseParams,
  });

  const breadcrumb = {
    ...breadcrumbBaseParams,
    context: responseItem.context,
    exclude: baseParamsExtension.exclude,
    hitSetKey: searchFilterResult.hitSetKey,
    resultName: responseItem.resultName,
    recordCount: responseItem.recordCount,
    synthesisProducts,
    synthesisPlanId,
    synthesisBranchId,

    searchId: getSearchId(originalSearch, state),

    order: originalSearch.order,
    sort: originalSearch.sort,

    facets,
  };

  if (heatmapMode) {
    breadcrumb.heatmapResultName = searchFilterResult.resultName;
    breadcrumb.isHeatmapShown = true;
  }

  return breadcrumb;
}
